import React from 'react'

import StageContainer from '../../../../../Webinar/components/stage-container/stage-container'

const FocusStage = () => {
  return <StageContainer />
}
export { FocusStage }
